module.exports = __webpack_public_path__ + "img/80.6.CODm.0672141a.png";